import React, { FC, HTMLAttributes, ReactNode } from 'react'
import { AvatarType, convertAvatarSizeToCentraUi } from '../Avatar'
import { Avatar, Box } from '@centra/centra-ui'

export interface AvatarInfoType extends AvatarType {
  children?: ReactNode
  vertical?: boolean
  center?: boolean
  loading?: boolean
}

/**
 * @deprecated
 */
const AvatarInfo: FC<AvatarInfoType & HTMLAttributes<HTMLDivElement>> = (
  props: AvatarInfoType & HTMLAttributes<HTMLDivElement>
) => {
  const size = convertAvatarSizeToCentraUi(props.size)
  const marginHorizontal = props.size === 'lg' || props.size === 'xxl' || props.size === 'xl' ? 16 : 8

  // Весь AvatarInfo надо убирать, так как в нем инкапсулировано слишком много нюансов, которые проще решать на местах
  // Вот например как эта ценровка, которая автоматом старвится, если компонент рендерит что-то горизонтально
  const alignItems = !props.vertical || props.center ? 'center' : 'start'

  return (
    <Box alignItems={alignItems} column={props.vertical}>
      <Avatar
        className={props.className}
        imageUrl={props.avatar}
        grayscale={props.grayscale}
        size={size}
        firstName={props.firstName}
        lastName={props.lastName}
        storage={props.storage}
        onClick={props.onClick}
        loading={props.loading}
        withBg={props.withBg}
        style={{ alignItems: 'center', ...props.style }}
      />
      <Box
        column
        fullWidth
        marginTop={props.vertical ? 8 : undefined}
        marginLeft={props.vertical ? undefined : marginHorizontal}
        style={{ textAlign: props.center ? 'center' : 'inherit' }}
      >
        {props.children}
      </Box>
    </Box>
  )
}

/**
 * @deprecated
 */
export default AvatarInfo
